/* All feather icons -> https://github.com/michaelbazos/angular-feather#available-icons */

import {
    Activity,
    AlertTriangle,
    Archive,
    ArrowRight,
    ArrowUpLeft,
    Award,
    BarChart,
    Bell,
    Book,
    Bookmark,
    BookOpen,
    Calendar,
    Check,
    CheckCircle,
    ChevronDown,
    ChevronRight,
    ChevronUp,
    Circle,
    Clipboard,
    CloudRain,
    Code,
    Copy,
    CornerRightDown,
    Database,
    Download,
    Droplet,
    Edit,
    Edit3,
    ExternalLink,
    Eye,
    Feather,
    File,
    FileText,
    Film,
    Filter,
    Flag,
    Globe,
    Heart,
    HelpCircle,
    Home,
    Info,
    Layers,
    Layout,
    Link,
    Lock,
    LogOut,
    Mail,
    Maximize,
    Menu,
    Moon,
    MoreVertical,
    MousePointer,
    Package,
    PieChart,
    PlusCircle,
    Repeat,
    Search,
    Settings,
    Share,
    ShoppingCart,
    Sidebar,
    Sliders,
    Sun,
    Sunset,
    Tool,
    Trash2,
    TrendingDown,
    TrendingUp,
    Type,
    User,
    UserPlus,
    Users,
    XCircle,
    Zap,
    ZapOff,
} from 'angular-feather/icons';

export const featherIcons = {
    Activity,
    AlertTriangle,
    Archive,
    ArrowUpLeft,
    BarChart,
    Award,
    ArrowRight,
    Bell,
    Book,
    Bookmark,
    BookOpen,
    Calendar,
    Check,
    CheckCircle,
    ChevronUp,
    ChevronDown,
    ChevronRight,
    Circle,
    Clipboard,
    CloudRain,
    Code,
    Copy,
    CornerRightDown,
    Database,
    Download,
    Droplet,
    Edit,
    Edit3,
    ExternalLink,
    Eye,
    Feather,
    File,
    FileText,
    Film,
    Filter,
    Flag,
    Globe,
    Heart,
    HelpCircle,
    Home,
    Info,
    Layers,
    Layout,
    Link,
    Lock,
    LogOut,
    Mail,
    Maximize,
    Menu,
    Moon,
    MoreVertical,
    MousePointer,
    Package,
    PieChart,
    PlusCircle,
    Repeat,
    Search,
    Settings,
    Share,
    ShoppingCart,
    Sidebar,
    Sliders,
    Sun,
    Sunset,
    Tool,
    Trash2,
    TrendingDown,
    TrendingUp,
    Type,
    User,
    UserPlus,
    Users,
    XCircle,
    Zap,
    ZapOff,
};
